import React from 'react';
import { AnimateOnScroll } from '../AnimateOnScroll';
interface FillerCardProps {
  brand: string;
  name: string;
  description: string;
  delay: number;
}
function FillerCard({
  brand,
  name,
  description,
  delay
}: FillerCardProps) {
  return <AnimateOnScroll delay={delay} data-id="element-905">
      <div className="bg-white p-8 shadow-[0_4px_20px_rgba(0,0,0,0.06)] border-t-[3px] border-[#FF1493] h-full" data-id="element-906">
        <h3 className="text-xl font-bold font-[Poppins,_sans-serif] mb-3" data-id="element-907">
          <span className="text-[#FF1493]" data-id="element-908">{brand}</span>{' '}
          <span className="text-black" data-id="element-909">{name}</span>
        </h3>
        <p className="text-[#333333] text-[15px] leading-[1.6] font-body" data-id="element-910">
          {description}
        </p>
      </div>
    </AnimateOnScroll>;
}
export function DFProducts() {
  const fillers = [{
    brand: 'Juvederm',
    name: 'Ultra',
    description: 'Crafted for perioral rejuvenation and lip enhancement, Juvederm Ultra offers versatility in results, ranging from subtle enhancement to striking definition. Explore the possibilities with Juvederm Ultra.'
  }, {
    brand: 'Juvederm',
    name: 'Ultra Plus',
    description: 'With its heightened viscosity, Juvederm Ultra Plus is tailored for the perioral region, delivering ample volume and lift for dramatic rejuvenation.'
  }, {
    brand: 'Juvederm',
    name: 'Vollure',
    description: 'Boasting intermediate density, Juvederm Vollure is the go-to for volumizing and smoothing wrinkles and folds, offering natural-looking results with lasting impact.'
  }, {
    brand: 'Juvederm',
    name: 'Volbella',
    description: 'As the softest option in hylacross & vycross technology, Juvederm Volbella achieves unparalleled naturalness, sculpting soft, supple lips and surrounding areas with fluid precision.'
  }, {
    brand: 'Juvederm',
    name: 'Voluma',
    description: 'Engineered with heightened density, Juvederm Voluma is ideal for lifting and augmenting larger areas like the cheeks, providing profound enhancement with a single treatment.'
  }, {
    brand: 'Restylane',
    name: 'Refyne',
    description: 'Tailored to soften laugh lines while preserving natural facial expressions, Restylane Refyne ensures a seamless blend of rejuvenation and authenticity.'
  }, {
    brand: 'Restylane',
    name: 'Defyne',
    description: 'Designed to address deeper laugh lines and enhance facial contours, Restylane Defyne offers natural movement and expression without compromise.'
  }, {
    brand: 'Restylane',
    name: 'Lyft',
    description: 'A trusted choice for natural-looking volume, Restylane Lyft enhances cheekbones and rejuvenates hands, providing smooth, full results with FDA-approved safety.'
  }, {
    brand: 'Restylane',
    name: 'Contour',
    description: 'The latest addition to the Restylane family, Restylane Contour sculpts cheeks and contours the face with natural-looking shape and volume, elevating your aesthetic journey.'
  }, {
    brand: 'Restylane',
    name: 'Kysse',
    description: 'Specially formulated for dynamic lip movement and natural volume, Restylane Kysse enhances lip texture and color while preserving flexibility and expression.'
  }, {
    brand: 'Restylane',
    name: 'Silk',
    description: 'Tailored for softening wrinkles around the mouth and enhancing lip contours, Restylane Silk delivers subtle yet transformative results for a refreshed appearance.'
  }];
  return <section className="bg-[#ECECEC] py-[60px] lg:py-[100px]" data-id="element-911">
      <div className="max-w-[1200px] mx-auto px-6 lg:px-8" data-id="element-912">
        <AnimateOnScroll className="text-center flex flex-col items-center mb-12" data-id="element-913">
          <span className="text-[#FF1493] uppercase text-sm font-bold tracking-[3px] mb-4 font-[Poppins,_sans-serif]" data-id="element-914">
            Be BRIGHT
          </span>

          <h2 className="text-[28px] lg:text-[44px] uppercase text-black leading-tight mb-6 font-[600] font-[Poppins,_sans-serif]" data-id="element-915">
            GET TO KNOW THE FILLERS WE LOVE
          </h2>

          <p className="text-[#333333] text-[17px] leading-[1.7] font-body max-w-[800px] mb-6" data-id="element-916">
            Whether it's plumping up thin lips or easing the appearance of
            under-eye hollows, the versatility of dermal fillers, combined with
            the regenerative benefits of PRF injections, provides comprehensive
            facial enhancement options:
          </p>

          <div className="w-[40px] h-[2px] bg-[#FF1493]" data-id="element-917"></div>
        </AnimateOnScroll>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-918">
          {fillers.map((filler, index) => <FillerCard key={index} brand={filler.brand} name={filler.name} description={filler.description} delay={index * 60} data-id="element-919" />)}
        </div>
      </div>
    </section>;
}